import React, {useMemo} from "react";
import Lookup, {LookupProps} from "fulogics-ui-web/dist/layout/dx/Lookup/Lookup";
import gridCellData from "fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData";
import ProductInfoModelSimpleText, {
    ProductInfoModelSimpleTextData,
    ProductInfoModelSimpleTextDataKeys
} from "../../../../components/product-info-model-simple-text/ProductInfoModelSimpleText";
import { CellTemplateProps } from "fulogics-ui-web/dist/layout/dx/DataGrid/templates/CellTemplateProps";
import { GridCellTemplateHelper } from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridCellTemplateHelper';

const ProductInfoColumnTemplate = (props: CellTemplateProps) => {

    const data = gridCellData(props)
    //
    return (<React.Fragment>
        <GridCellTemplateHelper cellProps={props}>
            {(inspectorId, disableInspectorForm) =>
                <ProductInfoModelSimpleText
                    disableInspectorForm={disableInspectorForm}
                    inspectorId={inspectorId}
                    //
                    data={data}
                />
            }
        </GridCellTemplateHelper>
    </React.Fragment>)
}

export default ProductInfoColumnTemplate;
